import React, { useContext } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { Context } from '../context';
import { PhotoCard } from './PhotoCard';
import Masonry from 'react-masonry-css';
import { Card } from 'antd';
import { Txt } from './UiKit/Txt';

export function Books(props) {
  const {
    size = 'l',
    category,
  } = { ...props };

  const [searchParams] = useSearchParams();
  const context = useContext(Context);

  const filterCat = (arr) => {
    if (!category) {
      return arr;
    } else {
      return arr.filter(one => one.categories.includes(category))
        .sort((a, b) => b.order - a.order)
        .sort((a, b) => b.link.length - a.link.length);
    }
  };

  const filteredBooks = filterCat(context.books);

  return (
    <>
      <div className="w _w--100" id="book">
        <div className="x_v">
          <br />
          <br />
          {Boolean(filteredBooks.length) && (
            <div className="x_v_c">
              <Masonry
                breakpointCols={{ default: 6, 1400: 4, 991: 3, 768: 2, 479: 1 }}
                className="my-masonry-grid my-masonry-grid--books"
                columnClassName="my-masonry-grid_column my-masonry-grid_column--books"
              >
                {filteredBooks.map(oneBook => (
                  <BookCard
                    size={size}
                    key={oneBook._id}
                    {...oneBook}
                  />
                ))}
              </Masonry>
            </div>
          )}
        </div>
      </div>
    </>
  );
}






export function BookCard(book) {
  const {
    _id,
    id,
    title,
    title_sub,
    order,
    link,
    description,
    image: {
      thumbnails: { large }
    }
  } = { ...book }

  return (
    <>
      <div className="_rel _tl my-masonry-grid_item my-masonry-grid_item--books _fv _fgap08"
        key={_id}
      >

        {/* <div className="x_hover" /> */}


      {!Boolean(link) && <img className="my-masonry-grid_item_img" src={large.url} alt={id} style={{ width: large.widtht }} />}
      {Boolean(link) && <a className="x_link_img" href={link} target="_blank"><img className="my-masonry-grid_item_img" src={large.url} alt={id} style={{ width: large.widtht }} /></a>}



      <div className="_fv _fgap02">
        <h4 style={{ marginBottom: 0, marginTop: 0 }}>{title}</h4>
        <h5 style={{ marginBottom: 0, marginTop: 0 }}>{title_sub}</h5>
        <div className="_t08">
          <Txt>{description}</Txt>
        </div>

        {!Boolean(link) && <div className="_f _fm _fgap04 _fwrap" >
          {/* <div className="x_button disabled" >
            Buy digital
          </div>  */}
          <strong>Coming Soon</strong>
        </div>}

        {Boolean(link) && <div className="_f _fm _f100" >
          <a href={link} target="_blank" className="x_button active" >
            Buy digital
          </a>
        </div>}


      </div>
      
      </div>

    </>
  )
}